import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../Core/Store";

export interface IParamSliceState {
  customerID: string;
  mainMachineSerialNo: string;
  customerAssemblyDeviceIDs: any;
  machine: any;
}
const getInitialFilters = () => {
  return {
    customerID: null,
    mainMachineSerialNo: null,
    customerAssemblyDeviceIDs: null,
    machine: null,
  };
};
const initialState: any = getInitialFilters();

export const updateParams2 = createAsyncThunk(
  "params/updateParams",
  async (params: IParamSliceState, thunkAPI: any) => {
    const path = thunkAPI.getState().router.location.pathname;

    //if (!isEqual(thunkAPI.getState().params, params)) {
    //  thunkAPI.dispatch(push(path, params));
    //}
    return params;
  }
);

const paramSlice = createSlice({
  name: "params",
  initialState,
  reducers: {
    updateParams: (state, action: PayloadAction<any>) => {
      if (action.payload === null) {
        return initialState;
      }
      return action.payload;
    },
  },
  //  ,
  //extraReducers(builder) {
  //  builder.addCase(updateParams.fulfilled, (state, action) => {
  //    return action.payload;
  //  });
  //},
});

export const { updateParams } = paramSlice.actions;

export const getParamsSelector = (state: RootState) => state.params;

export default paramSlice.reducer;
